import { Box } from '@material-ui/core';
import React from 'react';
import { ReactComponent as Loader } from 'images/loader.svg';
import { AnalysisConnectionNotice } from 'features/connectivity';
import styles from './apiLoader.module.css';

const ApiLoader = () => {
    return (
        <Box className={styles.loader}>
            <Loader className={styles.loaderIcon} />
            <p className={styles.loaderText}>Loading...</p>
            <AnalysisConnectionNotice />
            <p className={styles.suggestion}>Please wait, don’t close this tab.</p>
        </Box>
    );
};

export default ApiLoader;
